import { Navigation, Pagination } from "swiper/modules";
import { SwiperOptions } from "swiper/types";

export const teaserCardSliderOptions: SwiperOptions = {
  spaceBetween: 17,
  slidesPerView: 2.25,
  slidesPerGroup: 1,
  grabCursor: true,
  speed: 700,
  modules: [Pagination],
  observer: true,
  direction: "horizontal",
  mousewheel: {
    forceToAxis: true,
  },
  navigation: {
    enabled: true,
    nextEl: ".swiper-button-next-teaser-swiper",
    prevEl: ".swiper-button-prev-teaser-swiper",
  },
  pagination: {
    enabled: true,
    clickable: true,
    type: "bullets",
  },
  injectStyles: [
    `  /*   .swiper {
        overflow: visible;
      } */
      .swiper-pagination {
        padding: 30px;
        display: flex;
        position: relative;
        bottom: 0;
        justify-content: center;
      }
 
      .swiper-pagination-bullet-active {
        width: 40px;
        border-radius: 16px;
      }
       @media only screen and (min-width: 1200px) {
       .swiper-pagination-bullet {
        --swiper-pagination-bottom: 52%;
        display: none;} 
      }
  
    `,
  ],
  breakpoints: {
    0: {
      slidesPerView: 1.1,
      spaceBetween: 15,
    },
    480: {
      slidesPerView: 1.1,
      spaceBetween: 15,
    },
    768: {
      slidesPerView: "auto",
      spaceBetween: 15,
    },
    1190: {
      slidesPerView: 2.1,
    },
    1500: {
      slidesPerView: 2.25,
    },
    1600: {
      slidesPerView: 2.9,
    },
  },
};
